export const defaultLanguage = 'pt-BR';

export const languageMap: { [key: string]: string } = {
  pt: 'pt-BR',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-BR',
  en: 'en-US',
  'en-US': 'en-US',
  'en-GB': 'en-US',
  es: 'es-ES',
  'es-ES': 'es-ES',
  'es-MX': 'es-ES',
  'es-AR': 'es-ES',
  'es-CO': 'es-ES',
  'es-CL': 'es-ES',
};

export const mapLanguage = (lang: string): string | null => {
  if (!lang) return null;
  if (languageMap[lang]) {
    return languageMap[lang];
  }
  const langCode = lang.split('-')[0].toLowerCase();
  if (languageMap[langCode]) {
    return languageMap[langCode];
  }
  return null;
};

/**
 * Detects the machine language and maps it to a supported one, in order of
 * precedence: `?lang=` → saved preference → `<html lang>` → `navigator`.
 * Every read is guarded because storage and DOM access throw in embedded
 * WebViews and in Safari with storage blocked.
 */
export function detectLanguage(): string {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    if (urlLang) {
      const mapped = mapLanguage(urlLang);
      if (mapped) {
        return mapped;
      }
    }
  } catch {
    // unavailable — fall through to the next source
  }

  try {
    const savedLang = localStorage.getItem('actuar/language');
    if (savedLang) {
      const mapped = mapLanguage(savedLang);
      if (mapped) {
        return mapped;
      }
    }
  } catch {
    // unavailable — fall through to the next source
  }

  try {
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      const mapped = mapLanguage(htmlLang);
      if (mapped) {
        return mapped;
      }
    }
  } catch {
    // unavailable — fall through to the next source
  }

  if (navigator.languages && navigator.languages.length > 0) {
    for (const lang of navigator.languages) {
      const mapped = mapLanguage(lang);
      if (mapped) {
        return mapped;
      }
    }
  }

  const browserLang = navigator.language || (navigator as any).userLanguage;
  if (browserLang) {
    const mapped = mapLanguage(browserLang);
    if (mapped) {
      return mapped;
    }
  }

  return defaultLanguage;
}
